<template>
        <div class="spinner-container" @click="exit">
            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    </template>
    
    <script>
    
    import Alert from '@/utils/Alert.js'    
    import { mapMutations } from 'vuex'
    export default {
        methods: {
            exit() {
                Alert.yesno('Cancel wait ?',yes => {
                    yes && this.setValue({ showSpinner: false })
                })
            },
            ...mapMutations([
                'setValue'
            ])
        }
    }
    
    </script>
    
    <style lang="scss">
    
    .lds-spinner {
        color: official;
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
        transform: scale(3);
        top: calc(50% - 207px);
        left: calc(50% - 32px);
    }
    .lds-spinner div {
        transform-origin: 32px 32px;
        animation: lds-spinner 1.2s linear infinite;
    }
    .lds-spinner div:after {
        content: " ";
        display: block;
        position: absolute;
        top: 3px;
        left: 29px;
        width: 5px;
        height: 16px;
        border-radius: 20%;
        background: rgba(100,100,100,1);
    }
    .lds-spinner div:nth-child(1) {
        transform: rotate(0deg);
        animation-delay: -1.1s;
    }
    .lds-spinner div:nth-child(2) {
        transform: rotate(30deg);
        animation-delay: -1s;
    }
    .lds-spinner div:nth-child(3) {
        transform: rotate(60deg);
        animation-delay: -0.9s;
    }
    .lds-spinner div:nth-child(4) {
        transform: rotate(90deg);
        animation-delay: -0.8s;
    }
    .lds-spinner div:nth-child(5) {
        transform: rotate(120deg);
        animation-delay: -0.7s;
    }
    .lds-spinner div:nth-child(6) {
        transform: rotate(150deg);
        animation-delay: -0.6s;
    }
    .lds-spinner div:nth-child(7) {
        transform: rotate(180deg);
        animation-delay: -0.5s;
    }
    .lds-spinner div:nth-child(8) {
        transform: rotate(210deg);
        animation-delay: -0.4s;
    }
    .lds-spinner div:nth-child(9) {
        transform: rotate(240deg);
        animation-delay: -0.3s;
    }
    .lds-spinner div:nth-child(10) {
        transform: rotate(270deg);
        animation-delay: -0.2s;
    }
    .lds-spinner div:nth-child(11) {
        transform: rotate(300deg);
        animation-delay: -0.1s;
    }
    .lds-spinner div:nth-child(12) {
        transform: rotate(330deg);
        animation-delay: 0s;
    }
    @keyframes lds-spinner {
        0% {
        opacity: 1;
        }
        100% {
        opacity: 0;
        }
    }
    
    .spinner-container {
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(200,200,200,0.5);
        z-index: 29;
    }
    
    </style>